import React from 'react';
import {createSelector} from 'reselect';

import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';

const examItems = {
    True: {id: 'True', label: 'داشته'},
    False: {id: 'False', label: 'نداشته'},
};

const bookItems = {
    True: {id: 'True', label: 'داشته'},
    False: {id: 'False', label: 'نداشته'},
};

export default function(prefix='') {
    return createSelector.bind(this)(
        [
            store => store.get('regionsTreeFilter'),
            store => store.get('citiesTreeFilter'),
            store => store.get('schoolsTreeFilter'),
            store => store.get('gradesTreeFilter'),
            store => store.get('hasExamTreeFilter'),
            store => store.get('hasBookTreeFilter'),
        ],
        (regionsTreeFilter, citiesTreeFilter, schoolsTreeFilter, gradesTreeFilter, hasExamTreeFilter, hasBookTreeFilter) => [
            {
                field: prefix + 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={regionsTreeFilter}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: regionsTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    regionsTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={citiesTreeFilter}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            region: regionsTreeFilter.get('selected').keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: citiesTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    citiesTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'school',
                label: window.gettext('School'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={schoolsTreeFilter}
                        readonly
                        header
                        resource='school'
                        itemLabel={school => `${school.city.name} - ${school.name}`}
                        filter={{
                            city: citiesTreeFilter.get('selected').keySeq().join(',') || -1,
                        }}
                        label={window.gettext('School')}
                    />
                </div>,
                selected: schoolsTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'school',
                    schoolsTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'grade',
                label: window.gettext('Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={gradesTreeFilter}
                        readonly
                        header
                        resource='grade'
                        label={window.gettext('Grade')}
                    />
                </div>,
                selected: gradesTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    gradesTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'hasExam',
                label: 'شرکت در آزمون',
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={hasExamTreeFilter}
                        header
                        readonly
                        multiSelection={false}
                        resource='hasExam'
                        label='شرکت در آزمون'
                        staticItems={examItems}
                        //initial={defaults.online}
                    />
                </div>,
                selected: hasExamTreeFilter.get('selected').toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'hasExam',
                    hasExamTreeFilter.get('elementId'),
                )),
            },
            {
                field: prefix + 'hasBook',
                label: 'خرید کتاب',
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={hasBookTreeFilter}
                        header
                        readonly
                        multiSelection={false}
                        resource='hasBook'
                        label='خرید کتاب'
                        staticItems={bookItems}
                        //initial={defaults.online}
                    />
                </div>,
                selected: hasBookTreeFilter.get('selected').toJS(),
                remove: id => this?.context?.store.dispatch(removeItemSelection(
                    id,
                    'hasBook',
                    hasBookTreeFilter.get('elementId'),
                )),
            }
        ],
    );
}
